import { DateField, NumberField } from '../../../../types'

function withinBounds(value: NumberField) {
  return value.value <= value.max && value.value >= value.min
}

function withinBoundsMessage(fieldLabel: string, value: NumberField) {
  return `${fieldLabel} must be between ${value.min} and ${value.max}`
}

export function validateNumberField(fieldLabel: string, value: NumberField) {
  const isValid = withinBounds(value)
  const message = !isValid ? withinBoundsMessage(fieldLabel, value) : undefined

  return {
    isValid,
    message
  }
}

function withinBoundsDate(value: DateField) {
  return (
    new Date(value.value) <= new Date(value.max) && new Date(value.value) >= new Date(value.min)
  )
}

function withinBoundsDateMessage(fieldLabel: string, value: DateField) {
  return `${fieldLabel} must be between ${value.min} and ${value.max}`
}

export function validateDateField(fieldLabel: string, value: DateField) {
  const isValid = withinBoundsDate(value)
  const message = !isValid ? withinBoundsDateMessage(fieldLabel, value) : undefined

  return {
    isValid,
    message
  }
}
